<template>
  <div class="download-page">
    <!-- 顶部横幅 -->
    <section class="banner-section">
      <img src="@/assets/pic/lic-ban.jpg" alt="软件下载" class="banner-img" />
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <h1 class="banner-title">{{ $i18n.t("download.bannerTitle") }}</h1>
        <p class="banner-subtitle">{{ $i18n.t("download.bannerDesc") }}</p>
      </div>
    </section>

    <!-- 主内容区域 -->
    <section class="main-section">
      <div class="container">
        <!-- 区域标题 -->
        <div class="section-header scroll-animate fade-up" data-delay="0">
          <h2 class="secTitle">{{ $i18n.t("download.sectionTitle") }}</h2>
          <span>{{ $i18n.t("download.sectionSub") }}</span>
        </div>

        <!-- 交易平台介绍 -->
        <div class="content-block scroll-animate fade-up" data-delay="100">
          <p>{{ $i18n.t("download.platformDesc") }}</p>
        </div>

        <!-- 软件服务平台：左图片 右文字+卡片 -->
        <div class="platform-showcase scroll-animate fade-up" data-delay="200">
          <div class="showcase-grid">
            <!-- 右侧文字 + 下载卡片 -->
            <div class="showcase-right">
              <h3>{{ $i18n.t("download.serviceTitle") }}</h3>
              <p class="service-desc">{{ $i18n.t("download.serviceDesc") }}</p>

              <div class="app-subtitle">
                {{ $i18n.t("download.appSubtitle") }}
              </div>

              <!-- iOS / Android 下载卡片 -->
              <div class="app-cards">
                <div
                  v-for="(app, index) in appPlatforms"
                  :key="index"
                  class="app-card scroll-animate fade-up"
                  :data-delay="(index + 1) * 150"
                >
                  <span
                    class="platform-badge"
                    :style="{ backgroundColor: app.badgeColor }"
                    >{{ $i18n.t(app.badgeKey) }}</span
                  >
                  <div class="app-icon" v-html="app.icon"></div>
                  <p class="app-download-text">
                    ({{ $i18n.t(app.downloadTextKey) }})
                  </p>
                </div>
              </div>
            </div>
            <!-- 左侧大图 -->
            <div
              class="showcase-left scroll-animate fade-left"
              data-delay="200"
            >
              <img
                src="@/assets/pic/6.jpg"
                alt="交易平台展示"
                class="showcase-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { useScrollAnimation } from "../composables/useScrollAnimation";
useScrollAnimation();

const appPlatforms = [
  {
    badgeKey: "download.iosBadge",
    badgeColor: "#4779B5",
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="#1a3a5c"><path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.83-3.12 1.87-2.38 5.98.49 7.13-.57 1.5-1.31 2.99-2.54 4.05zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/></svg>',
    downloadTextKey: "download.iosDownloadText",
  },
  {
    badgeKey: "download.androidBadge",
    badgeColor: "#4779B5",
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="#1a3a5c"><path d="M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85-.29-.15-.65-.06-.83.22l-1.88 3.24c-2.86-1.21-6.08-1.21-8.94 0L5.65 5.67c-.19-.29-.54-.38-.83-.22-.3.16-.42.54-.26.85L6.4 9.48C3.3 11.25 1.28 14.44 1 18h22c-.28-3.56-2.3-6.75-5.4-8.52zM7 15.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm10 0c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"/></svg>',
    downloadTextKey: "download.androidDownloadText",
  },
];
</script>

<style scoped>
.download-page {
  min-height: 100vh;
}

/* ====== 横幅区域 ====== */
.banner-section {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(0, 20, 40, 0.85) 0%,
    rgba(0, 20, 40, 0.7) 60%,
    transparent 100%
  );
  pointer-events: none;
  z-index: 1;
}

.banner-img {
  width: 100%;
  /* height: 25rem; */
  object-fit: cover;
  display: block;
}

.banner-content {
  position: absolute;
  top: 50%;
  left: 12rem;
  transform: translateY(-50%);
  z-index: 2;
}

.banner-title {
  font-size: 3rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 0.75rem;
  letter-spacing: 0.125rem;
}

.banner-subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  max-width: 31.25rem;
}

/* ====== 容器 ====== */
.container {
  max-width: 87rem;
  margin: 0 auto;
  padding: 0 1.25rem;
}

/* ====== 区域标题 - 居中+短线 ====== */
.section-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3rem;
}

.secTitle {
  font-size: 1.75rem;
  font-weight: bold;
  color: #1a3a5c;
  display: inline-block;
  position: relative;
  padding-bottom: 1.1rem;
  margin-bottom: 0;
}

.secTitle::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 3rem;
  height: 0.1875rem;
  background-color: #4779b5;
  border-radius: 0.0625rem;
}

.section-header span {
  font-size: 1rem;
  color: #999;
  letter-spacing: 0.1875rem;
  margin-top: 0.625rem;
}

/* ====== 主内容区域 ====== */
.main-section {
  padding: 5rem 0;
  background-color: #fff;
}

/* ====== 内容块（蓝色左边框） ====== */
/* .content-block {
  border-left: 0.1875rem solid #4779B5;
  padding-left: 1.875rem;
  margin-bottom: 3rem;
} */

.content-block p {
  font-size: 1.2rem;
  line-height: 2;
  color: #555;
  text-align: justify;
}

/* ====== 软件服务平台展示（左图 右文字+卡片） ====== */
.platform-showcase {
  margin: 4rem 0;
}

.showcase-grid {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 4rem;
  align-items: center;
}

/* 左侧大图 */
.showcase-left {
  position: relative;
}

.showcase-img {
  width: 100%;
  height: auto;
  border-radius: 0.5rem;
  display: block;
}

/* 右侧内容 */
.showcase-right {
  display: flex;
  flex-direction: column;
}

.showcase-right h3 {
  font-size: 1.375rem;
  font-weight: bold;
  color: #1a3a5c;
  margin-bottom: 1.1rem;
}

.service-desc {
  font-size: 1.2rem;
  line-height: 2;
  color: #555;
  margin-bottom: 2rem;
}

.app-subtitle {
  font-size: 1.4rem;
  font-weight: bold;
  color: #1a3a5c;
  margin-bottom: 1.25rem;
}

/* iOS / Android 下载卡片 */
.app-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.875rem;
}

.app-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1.5625rem 1.5625rem;
  background: #fff;
  border-radius: 0.625rem;
  box-shadow: 0 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.08),
    0 0.125rem 0.25rem -0.125rem rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.app-card:hover {
  transform: translateY(-0.1875rem);
  box-shadow: 0 0.625rem 1.5rem rgba(71, 121, 181, 0.12);
}

.platform-badge {
  padding: 0.25rem 1rem;
  border-radius: 1.875rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: #fff;
  margin-bottom: 1.25rem;
}

.app-icon {
  width: 4rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.75rem;
}

.app-icon :deep(svg) {
  width: 3rem;
  height: 3rem;
}

.app-download-text {
  font-size: 1rem;
  color: #666;
}

/* ====== 响应式设计 ====== */
@media (max-width: 48rem) {
  .banner-section {
    height: 17.5rem;
  }

  .banner-img {
    height: 17.5rem;
  }

  .banner-content {
    left: 1.875rem;
  }

  .banner-title {
    font-size: 1.5rem;
  }

  .banner-subtitle {
    font-size: 1rem;
  }

  .showcase-grid {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }

  .app-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;
  }

  .main-section {
    padding: 3.125rem 0;
  }
}

@media (max-width: 30rem) {
  .banner-title {
    font-size: 1.5rem;
  }
}
</style>
